import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f1a6d35"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "configuration-page" }
const _hoisted_2 = { class: "configuration-tabs bg-white radius-7 mb-20" }
const _hoisted_3 = {
  class: "configuration-tabs__list",
  role: "tablist",
  "aria-label": "Configuracoes"
}
const _hoisted_4 = ["aria-selected", "aria-controls", "onClick"]
const _hoisted_5 = {
  id: "configuration-tab-whatsapp",
  role: "tabpanel",
  class: "configuration-tab-panel"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = {
  id: "configuration-tab-goals",
  role: "tabpanel",
  class: "configuration-tab-panel"
}
const _hoisted_11 = {
  id: "configuration-tab-hours",
  role: "tabpanel",
  class: "configuration-tab-panel"
}
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-xxl-7 col-xl-9" }
const _hoisted_14 = {
  id: "configuration-tab-users",
  role: "tabpanel",
  class: "configuration-tab-panel"
}
const _hoisted_15 = {
  id: "configuration-tab-services",
  role: "tabpanel",
  class: "configuration-tab-panel"
}
const _hoisted_16 = {
  id: "configuration-tab-payments",
  role: "tabpanel",
  class: "configuration-tab-panel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WhatsappConfigurations = _resolveComponent("WhatsappConfigurations")!
  const _component_AdvancedInitialWhatsappMessageConfig = _resolveComponent("AdvancedInitialWhatsappMessageConfig")!
  const _component_InitialWhatsappMessageConfig = _resolveComponent("InitialWhatsappMessageConfig")!
  const _component_UraTreeView = _resolveComponent("UraTreeView")!
  const _component_GoalsList = _resolveComponent("GoalsList")!
  const _component_OperatingHoursConfig = _resolveComponent("OperatingHoursConfig")!
  const _component_UsersList = _resolveComponent("UsersList")!
  const _component_CategoriesList = _resolveComponent("CategoriesList")!
  const _component_SubcategoriesList = _resolveComponent("SubcategoriesList")!
  const _component_ServicesList = _resolveComponent("ServicesList")!
  const _component_PaymentMethodsList = _resolveComponent("PaymentMethodsList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
          return (_openBlock(), _createElementBlock("button", {
            key: tab.key,
            type: "button",
            class: _normalizeClass(["configuration-tabs__button", { active: _ctx.activeTab === tab.key }]),
            role: "tab",
            "aria-selected": _ctx.activeTab === tab.key,
            "aria-controls": `configuration-tab-${tab.key}`,
            onClick: ($event: any) => (_ctx.setActiveTab(tab.key))
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(tab.icon)
            }, null, 2),
            _createElementVNode("span", null, _toDisplayString(tab.label), 1)
          ], 10, _hoisted_4))
        }), 128))
      ])
    ]),
    _withDirectives(_createElementVNode("section", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_WhatsappConfigurations, { "disabled-by-plan": _ctx.isAttendantUnavailable }, null, 8, ["disabled-by-plan"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.isAdvancedAttendant)
            ? (_openBlock(), _createBlock(_component_AdvancedInitialWhatsappMessageConfig, { key: 0 }))
            : (_openBlock(), _createBlock(_component_InitialWhatsappMessageConfig, {
                key: 1,
                "disabled-by-plan": _ctx.isAttendantUnavailable
              }, null, 8, ["disabled-by-plan"]))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_UraTreeView, { "disabled-by-plan": _ctx.isAttendantUnavailable }, null, 8, ["disabled-by-plan"])
        ])
      ])
    ], 512), [
      [_vShow, _ctx.activeTab === 'whatsapp']
    ]),
    _withDirectives(_createElementVNode("section", _hoisted_10, [
      _createVNode(_component_GoalsList)
    ], 512), [
      [_vShow, _ctx.activeTab === 'goals']
    ]),
    _withDirectives(_createElementVNode("section", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_OperatingHoursConfig)
        ])
      ])
    ], 512), [
      [_vShow, _ctx.activeTab === 'hours']
    ]),
    _withDirectives(_createElementVNode("section", _hoisted_14, [
      _createVNode(_component_UsersList)
    ], 512), [
      [_vShow, _ctx.activeTab === 'users']
    ]),
    _withDirectives(_createElementVNode("section", _hoisted_15, [
      _createVNode(_component_CategoriesList),
      _createVNode(_component_SubcategoriesList),
      _createVNode(_component_ServicesList)
    ], 512), [
      [_vShow, _ctx.activeTab === 'services']
    ]),
    _withDirectives(_createElementVNode("section", _hoisted_16, [
      _createVNode(_component_PaymentMethodsList)
    ], 512), [
      [_vShow, _ctx.activeTab === 'payments']
    ])
  ]))
}